import React from 'react'

const NotFound = () => {
    return (
        <div className="container">
            <div className="notFound">
                <h1>Error 404 - Bunday Sahifa Mavjud Emas</h1>
            </div>
        </div>
    )
}

export default NotFound
